// components
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { SmartAction } from './SmartAction';

// hooks
import { useTranslation } from 'react-i18next';

// types
import { AppointmentRecurrenceType } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import type {
  RecurrenceActionType,
  SmartActionComponentProps
} from '../SmartActionDialog.types';
import { SmartActionType } from '../SmartActionDialog.types';

type RecurrenceActionProps = SmartActionComponentProps & {
  actionType?: RecurrenceActionType;
};

export const RecurrenceAction = ({
  state,
  actionType = 'update',
  onSelect,
  setCanContinue
}: RecurrenceActionProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  return (
    <SmartAction
      state={state}
      title={t('dialogs.recurrence.title', {
        action: t(`dialogs.recurrence.actions.${actionType}`)
      })}
    >
      <RadioGroup
        aria-labelledby="smart-action-recurrence-radio-buttons-group"
        onChange={(_, value) => {
          setCanContinue(true);

          onSelect({
            type: SmartActionType.RECURRENCE_ACTION,
            editAppointmentType: value as AppointmentRecurrenceType
          });
        }}
      >
        <FormControlLabel
          value={AppointmentRecurrenceType.ONLY_THIS}
          control={<Radio autoFocus />}
          label={t('onlyThis')}
        />
        <FormControlLabel
          value={AppointmentRecurrenceType.THIS_AND_ALL_SUBSEQUENT}
          control={<Radio />}
          label={t('thisAndSubsequentAppointments')}
        />
      </RadioGroup>
    </SmartAction>
  );
};
